// removed by extract-text-webpack-plugin
module.exports = {"CookieBanner":"CookieBanner__CookieBanner___2MCQy","Title":"CookieBanner__Title___39sF-","Link":"CookieBanner__Link___31aCV","Button":"CookieBanner__Button___3ki9X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CookieBanner/CookieBanner.scss
// module id = 1405
// module chunks = 0